// extracted by mini-css-extract-plugin
export var root = "generic-page-copy-module--root--8cea5";